import App from 'app/app.js';
import 'app/store/MessageStore.js';
import { getMemoizedSubjectParams } from '@app/service/StickyBarUtilService';
import 'app/service/ValidationService.js';
import 'app/store/ContentStore.js';

// eslint-disable-next-line max-lines-per-function
function LtTextPersonalizerCtrl(MessageStore, ContentStore, ValidationService, ShoppingCartStore, $scope) {
  this.errors = [];
  this.invalidFieldata = false;

  this.onGoBack = () => $scope.onGoBack();

  this.onClickOfPersonalizerButton = () => {
    MessageStore.clear();
    this.errors = this.validateData();

    if (this.errors.length <= 0) {
      $scope.onClickOfPersonalizerButton();
    }
  };

  this.getFieldErrors = (fieldName) => R.filter((err) => err.fieldName === fieldName)(this.errors);

  this.onUpdateQuantity = (count) => {
    $scope.onUpdateQuantity({ count });
  };

  this.onProcessQuantity = (count) => {
    $scope.onProcessQuantity({ count });
  };

  this.validateData = () => {
    let validations = [];
    R.forEach((item) => {
      const validationData = item.getValidationData();
      if (validationData) {
        validationData[0].field.$setTouched();
        validations = R.concat(validations, validationData);
      }
    }, $scope.models);
    return ValidationService.validateSelectionTemplate(validations);
  };

  this.hasSystemErrorMessage = () => !R.isEmpty(MessageStore.getSystemMessages());

  this.getProductDescription = () => {
    if ($scope.orderLineDetail) {
      const item = $scope.orderLineDetail.item;
      return ContentStore.getProductDescription(item.skuCode, item.defaultLayoutThemeId);
    }
    return '';
  };

  this.onPersonalizationChanged = () => {
    this.invalidFieldata = ($scope.models || []).some((item) => item.isFieldDataInvalid());
  };

  this.updateBtnLabelForCYOP = () =>
    $scope.models[0] && $scope.models[0].getFieldData() ? 'CONTINUE_TO_NEXT' : 'ENTER_PERSONALIZATION';

  this.hasValidationErrors = () =>
    ($scope.models || []).some((item) => {
      if (!item.getValidationData) {
        return false;
      }

      const validationData = item.getValidationData();
      if (!Array.isArray(validationData)) {
        return false;
      }

      return validationData.some(
        (validation) => validation.field && validation.field.$invalid && validation.field.$error[validation.validation]
      );
    });

  this.isActionDisabled = () => this.invalidFieldata || this.hasValidationErrors();

  this.getStickyBarSubheadlineParams = () => {
    const subjectName = ShoppingCartStore.getCurrentSubject()?.subjectFirstName;
    this._stickyBarSubheadlineParams = getMemoizedSubjectParams(this._stickyBarSubheadlineParams, subjectName);

    return this._stickyBarSubheadlineParams;
  };
}

App.controller('LtTextPersonalizerCtrl', [
  'MessageStore',
  'ContentStore',
  'ValidationService',
  'ShoppingCartStore',
  '$scope',
  LtTextPersonalizerCtrl
]);
